import Vue from "vue";
import Component from "vue-class-component";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "PrivacyPolicy" })
export default class PrivacyPolicy extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;

    public isProfiling: boolean = false;
    public isMarketing: boolean = false;

    public marketingChannels: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    public selectProfiling()
    {
        this.$emit("profiling", this.isProfiling);

        // Legacy forms
        document.dispatchEvent(new CustomEvent("privacy", { bubbles: true, detail: { type: "profiling", isProfiling: this.isProfiling } }));
    }

    public selectMarketing()
    {
        this.$emit("marketing", this.isMarketing);

        // Legacy forms
        document.dispatchEvent(new CustomEvent("privacy", { bubbles: true, detail: { type: "marketing", isMarketing: this.isMarketing } }));
    }

    public selectMarketingChannels()
    {
        this.$emit("marketingChannels", this.marketingChannels);

        // Legacy forms
        document.dispatchEvent(new CustomEvent("privacy", { bubbles: true, detail: { type: "marketingChannels", marketingChannels: this.marketingChannels } }));
    }
};